import OBTPagination from './OBTPagination';
export default OBTPagination;
